// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1nCAd","messages":"Chat_messages__1WID1","dateDivider":"Chat_dateDivider__1Y3bH"};